import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const QuarterlyHiringChart = ({ data, description }) => {
  // Data preparation for chart
  const quarterlyHiringTrendsData = () => {
    const quarterData = {};
    
    data
      .filter(candidate => candidate.stage === 'Hired' && candidate.quarter)
      .forEach(candidate => {
        if (!quarterData[candidate.quarter]) {
          quarterData[candidate.quarter] = 0;
        }
        quarterData[candidate.quarter]++;
      });
    
    // Convert to array and sort by quarter
    return Object.entries(quarterData)
      .map(([quarter, count]) => ({
        name: quarter,
        count
      }))
      .sort((a, b) => {
        // Sort by year then quarter
        const [aQ, aY] = a.name.split(' ');
        const [bQ, bY] = b.name.split(' ');
        return aY === bY ? aQ.localeCompare(bQ) : aY.localeCompare(bY);
      });
  };

  return (
    <div className="dashboard-card p-6 slide-in-up" style={{animationDelay: '800ms'}}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Quarterly Hiring Trends</h3>
        <div className="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Hiring Trends
        </div>
      </div>
      {description && (
        <p className="text-sm text-gray-600 mb-4">{description}</p>
      )}
      <ResponsiveContainer width="100%" height={250}>
        <BarChart 
          data={quarterlyHiringTrendsData()} 
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
          <XAxis 
            dataKey="name" 
            tickLine={false} 
            axisLine={false} 
            style={{ fontSize: '12px' }} 
          />
          <YAxis 
            tickLine={false} 
            axisLine={false} 
            style={{ fontSize: '12px' }} 
          />
          <Tooltip 
            contentStyle={{ 
              borderRadius: '8px', 
              border: 'none', 
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              fontSize: '12px'
            }}
            formatter={(value) => [`${value} hires`, 'Count']}
          />
          <Bar 
            dataKey="count" 
            fill="#8884d8" 
            name="Hires" 
            radius={[4, 4, 0, 0]}
            barSize={30}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default QuarterlyHiringChart;
